import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../services/api";
import { useAuth } from "../context/AuthContext";

export const useCancelInvitation = () => {
  const { user, token } = useAuth();
  const orgId = user?.schoolId || user?.orgId;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (invitationId: string) => {
      if (!orgId || !token) {
        throw new Error("Missing organization ID or token");
      }
      return api.users.deleteInvitation(invitationId, orgId, token);
    },
    onSuccess: () => {
      // Invalidate and refetch invitations
      queryClient.invalidateQueries({ queryKey: ["invitations", orgId] });
    },
  });
};

